
import Divisor from './Divisor';
import TituloNegrito from './TituloNegrito';

import Image from 'react-bootstrap/Image';

import header from '../images/a2a2-header.png'

import constantes from '../helpers/constanteHelper';
import { retornarTexto } from '../helpers/textoHelper';

function DetalhesCertificacaoA2A2({ resolucaoMobile, idioma }) {
    return (
        <>
            <Divisor />
            <TituloNegrito texto={retornarTexto(idioma, 'certificacaoA2A2')} />
            <Image style={{ height: '400px', objectFit: 'contain', padding: '20px' }} src={header} alt='logo' fluid />
            <span className='mt-4 mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: resolucaoMobile ? '16px' : '20px', textAlign: resolucaoMobile ? 'justify' : 'center', whiteSpace: 'pre-line' }}>
                {retornarTexto(idioma, 'descricaoCertificacaoA2A2Parte1')}<br /><br />
                {retornarTexto(idioma, 'descricaoCertificacaoA2A2Parte2')}<br /><br />
                {retornarTexto(idioma, 'descricaoCertificacaoA2A2Parte3')}<br /><br />
                {retornarTexto(idioma, 'descricaoCertificacaoA2A2Parte4')}<br /><br />
            </span>
        </>
    );
}
export default DetalhesCertificacaoA2A2;
